import * as React from "react";
import { SVGProps } from "react";

export const ImagePlaceholderSvg = (
	props: SVGProps<SVGSVGElement> & { size?: "lg" | "md" | "sm" },
) => {
	const { size = "lg" } = props;

	if (size === "sm") {
		return (
			<svg
				width={24}
				height={24}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				{...props}
			>
				<path
					d="M10.5909 3.51562C10.5909 4.44803 10.2205 5.34224 9.56124 6.00155C8.90193 6.66085 8.00771 7.03125 7.07531 7.03125C6.14291 7.03125 5.2487 6.66085 4.58939 6.00155C3.93008 5.34224 3.55969 4.44803 3.55969 3.51562C3.55969 2.58322 3.93008 1.68901 4.58939 1.0297C5.2487 0.370395 6.14291 0 7.07531 0C8.00771 0 8.90193 0.370395 9.56124 1.0297C10.2205 1.68901 10.5909 2.58322 10.5909 3.51562ZM16.5323 9.21516C16.4005 9.1491 16.2512 9.12618 16.1055 9.14965C15.9599 9.17312 15.8254 9.24179 15.7209 9.34594L10.5038 15.9694L6.76312 12.0712C6.62807 11.9813 6.46607 11.9409 6.3046 11.9568C6.14313 11.9727 5.99212 12.0439 5.87719 12.1584L0.75 18.2812V21.0938C0.75 21.4667 0.898158 21.8244 1.16188 22.0881C1.4256 22.3518 1.78329 22.5 2.15625 22.5H21.8438C22.0284 22.5 22.2113 22.4636 22.3819 22.393C22.5525 22.3223 22.7075 22.2187 22.8381 22.0881C22.9687 21.9575 23.0723 21.8025 23.143 21.6319C23.2136 21.4613 23.25 21.2784 23.25 21.0938V14.7656L16.5323 9.21516Z"
					fill="#0050FF"
					fillOpacity={0.2}
				/>
			</svg>
		);
	}

	if (size === "md") {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<path
					d="M14.1213 4.6875C14.1213 5.9307 13.6274 7.12299 12.7483 8.00206C11.8692 8.88114 10.677 9.375 9.43375 9.375C8.19055 9.375 6.99826 8.88114 6.11919 8.00206C5.24011 7.12299 4.74625 5.9307 4.74625 4.6875C4.74625 3.4443 5.24011 2.25201 6.11919 1.37294C6.99826 0.49386 8.19055 0 9.43375 0C10.677 0 11.8692 0.49386 12.7483 1.37294C13.6274 2.25201 14.1213 3.4443 14.1213 4.6875ZM22.0431 12.2869C21.8673 12.1988 21.6682 12.1682 21.4741 12.1995C21.2799 12.2308 21.1005 12.3224 20.9613 12.4613L14.005 21.2925L9.0175 16.095C8.83742 15.9751 8.62143 15.9212 8.40613 15.9424C8.19084 15.9636 7.9895 16.0586 7.83625 16.2113L1 24.375V28.125C1 28.6223 1.19754 29.0992 1.54917 29.4508C1.90081 29.8025 2.37772 30 2.875 30H29.125C29.3712 30 29.615 29.9515 29.8425 29.8573C30.07 29.763 30.2767 29.6249 30.4508 29.4508C30.6249 29.2767 30.763 29.07 30.8573 28.8425C30.9515 28.615 31 28.3712 31 28.125V19.6875L22.0431 12.2869Z"
					fill="#0050FF"
					fillOpacity="0.16"
				/>
			</svg>
		);
	}

	return (
		<svg
			width={56}
			height={56}
			viewBox="0 0 56 56"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24.7122 8.20312C24.7122 10.3787 23.8479 12.4652 22.3095 14.0036C20.7712 15.542 18.6847 16.4062 16.5091 16.4062C14.3335 16.4062 12.247 15.542 10.7086 14.0036C9.17019 12.4652 8.30594 10.3787 8.30594 8.20312C8.30594 6.02752 9.17019 3.94102 10.7086 2.40264C12.247 0.864255 14.3335 0 16.5091 0C18.6847 0 20.7712 0.864255 22.3095 2.40264C23.8479 3.94102 24.7122 6.02752 24.7122 8.20312ZM38.5755 21.502C38.2678 21.3479 37.9194 21.2944 37.5796 21.3492C37.2398 21.4039 36.9259 21.5642 36.6822 21.8072L24.5088 37.2619L15.7806 28.1662C15.4655 27.9564 15.0875 27.8621 14.7107 27.8992C14.334 27.9362 13.9816 28.1025 13.7134 28.3697L1.75 42.6562V49.2188C1.75 50.089 2.0957 50.9236 2.71106 51.5389C3.32641 52.1543 4.16101 52.5 5.03125 52.5H50.9688C51.3997 52.5 51.8263 52.4151 52.2244 52.2502C52.6225 52.0853 52.9843 51.8436 53.2889 51.5389C53.5936 51.2343 53.8353 50.8725 54.0002 50.4744C54.1651 50.0763 54.25 49.6497 54.25 49.2188V34.4531L38.5755 21.502Z"
				fill="#0050FF"
				fillOpacity={0.2}
			/>
		</svg>
	);
};
